module.exports = __webpack_public_path__ + "static/media/favicon.9ddf2b45.ico";